import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const FilterOrder = (props) => (<Svg viewBox="0 0 20 20" fill={props.fill ?? 'none'} {...props}>
    <Path d="M11.455 10.106V3.3335M11.455 3.3335L8.91534 5.87318M11.455 3.3335L13.9947 5.87318" stroke={props.stroke ?? '#8F95B2'} strokeWidth={1.25} strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M8.06878 9.89402L8.06878 16.6665M8.06878 16.6665L10.6085 14.1268M8.06878 16.6665L5.5291 14.1268" stroke={props.stroke ?? '#8F95B2'} strokeWidth={1.25} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default FilterOrder;
